export function getTimer(seconds) {
    seconds = Math.round(seconds);

    const hours = Math.floor(seconds / 3600);
    seconds -= hours * 3600;

    const minutes = Math.floor(seconds / 60);
    seconds -= minutes * 60;

    return (hours > 0 ? hours + ":" : "") + leadingZero(minutes) + ":" + leadingZero(seconds);
}

function leadingZero(time) {
    return time < 10 ? "0" + time : +time;
}